module.exports = {"450312100":"临桂镇","450312101":"六塘镇","450312102":"会仙镇","450312103":"两江镇","450312104":"五通镇","450312105":"四塘镇","450312106":"南边山镇","450312107":"中庸镇","450312108":"茶洞镇","450312204":"宛田瑶族乡","450312205":"黄沙瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450312.json
// module id = 2224
// module chunks = 0